import getConfig from 'next/config'
import { NextRouter } from 'next/router'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { ContextValue } from '@/context/Cities'
import { CanonicalFilter, GeoFilter } from '@/types/filter'
import provinceUtils from '@/utils/cities/province-utils'
import filtersMapper from '@/utils/filters-mapper'
import { goToPage } from '@/utils/go-to-page'

export const applyGeoFilters = (
  canonicalFilter: CanonicalFilter,
  cities: ContextValue,
  geoFiltersParam: GeoFilter[],
  lang: Locale,
  router: NextRouter
) => {
  const { publicRuntimeConfig } = getConfig()
  const url = new URL(router.asPath, publicRuntimeConfig.lisaWebsite)
  url.searchParams.delete('pag')

  if (geoFiltersParam.length === 0) {
    const cityName = cities.router.city ? cities.router.city.name : cities.router.area.name
    provinceUtils.citySupportsProvince(cityName, cities.list)
      ? goToPage(url.searchParams, router, linkBuilder.listingByArea.url(lang, cities.list, cities.router.area?.slug))
      : goToPage(url.searchParams, router, linkBuilder.listingByCity.url(lang, cities.list, cities.router.city.slug))
  } else if (geoFiltersParam.length === 1 && geoFiltersParam[0].kind === 'city') {
    const filter = geoFiltersParam[0]
    goToPage(
      url.searchParams,
      router,
      linkBuilder.listingByCity.url(lang, cities.list, cities.list.find((c) => c.slug === filter.slug)?.slug)
    )
  } else {
    // Build query parameters
    const byZone = filtersMapper.buildZoneFilter(geoFiltersParam)

    /**
     * Go to area page when there are at least 2 city filters or at least a city and a zone
     * For cities like ROME and VERONA go to city page
     */
    if (geoFiltersParam.some((filter) => filter.kind === 'city')) {
      goToPage(
        url.searchParams,
        router,
        linkBuilder.listingByArea.url(lang, cities.list, cities.router.area.referenceArea),
        byZone.byZone
      )
    } else {
      /**
       * When there will be zones from different cities,
       * we should handle it.
       * Currently we are only handling zones from one city
       */

      goToPage(
        url.searchParams,
        router,
        linkBuilder.listingByCity.url(
          lang,
          cities.list,
          cities.list.find((c) => c.city_zones.some((z) => z.slug === geoFiltersParam[0].slug))?.slug,
          canonicalFilter && canonicalFilter.slug[lang]
        ),
        byZone.byZone
      )
    }
  }
}
